import React from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import InboxMessageProp from '../../../../../propTypes/inboxMessageProp';
import { colors } from '../../../../../../../services/utilityFunctions';
import InboxContainer from '../InboxContainer';
import RSSIcon from '../icons/RSSIcon';

export default function NewsMessage({ message, onClick }) {
  const { feed, createdAt } = message;
  const { title, content } = feed;

  return (
    <InboxContainer
      style={{
        '--news-item-bg': colors('dynamic'),
        '--news-item-title': colors('inverse'),
        '--news-item-text': colors('inverse'),
      }}
      title={title}
      image={RSSIcon}
      createdAt={createdAt}
      onClick={onClick}
    >
      <Linkify>{content}</Linkify>
    </InboxContainer>
  );
}

NewsMessage.propTypes = {
  message: PropTypes.shape(InboxMessageProp.propType).isRequired,
  onClick: PropTypes.func.isRequired,
};
